'use strict';
import React, { createContext, useContext, useMemo, useSyncExternalStore } from 'react';
import {
	getIsLoggingOut as getLogoutState,
	setIsLoggingOut as setLogoutState,
	subscribeIsLoggingOut
} from '@/utils/logoutState';

const LogoutContext = createContext(null);

export const LogoutProvider = ({ children }) => {
	const isLoggingOut = useSyncExternalStore(
		subscribeIsLoggingOut,
		getLogoutState,
		() => false
	);

	const value = useMemo(() => ({
		isLoggingOut,
		setIsLoggingOut: setLogoutState
	}), [isLoggingOut]);

	return (
		<LogoutContext.Provider value={value}>
			{children}
		</LogoutContext.Provider>
	);
};

export const useLogout = () => {
	const context = useContext(LogoutContext);
	if (!context) {
		throw new Error('useLogout must be used within LogoutProvider');
	}
	return context;
};

